import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import sr from '@utils/sr';
import { srConfig, email, supportUrl } from '@config';
import styled from 'styled-components';
import { theme, mixins, media, Section, Heading } from '@styles';
const { colors, fontSizes, fonts } = theme;

const StyledContainer = styled(Section)`
  text-align: center;
  max-width: 600px;
  margin: 0 auto 100px;
  a {
    ${mixins.inlineLink};
  }
`;
const StyledHeading = styled(Heading)`
  display: block;
  color: ${colors.green};
  font-size: ${fontSizes.md};
  font-family: ${fonts.SFMono};
  font-weight: normal;
  margin-bottom: 20px;
  justify-content: center;
  ${media.desktop`font-size: ${fontSizes.sm};`};
  &:before {
    bottom: 0;
    font-size: ${fontSizes.sm};
    ${media.desktop`font-size: ${fontSizes.smish};`};
  }
  &:after {
    display: none;
  }
`;
const StyledTitle = styled.h4`
  margin: 0 0 20px;
  font-size: 60px;
  ${media.desktop`font-size: 50px;`};
  ${media.tablet`font-size: 40px;`};
  ${media.thone`font-size: 32px;`};
  ${media.phone`font-size: 26px;`};
`;
const StyledButtons = styled.div`
  ${mixins.flexCenter};
  flex-wrap: wrap;
  margin-top: 50px;
  a {
    margin: 10px;
  }
`;
const StyledEmailLink = styled.a`
  ${mixins.bigButton};
`;
const StyledSupportLink = styled.a`
  ${mixins.bigButton};
  background-color: ${colors.transGreen};
`;

const Contact = ({ data }) => {
  const { frontmatter, html } = data[0].node;
  const { title, buttonText } = frontmatter;
  const revealContainer = useRef(null);
  useEffect(() => sr.reveal(revealContainer.current, srConfig()), []);

  return (
    <StyledContainer id="contact" ref={revealContainer}>
      <StyledHeading>What&apos;s Next?</StyledHeading>

      <StyledTitle>{title}</StyledTitle>

      <div dangerouslySetInnerHTML={{ __html: html }} />

      <StyledButtons>
        <StyledEmailLink href={`mailto:${email}`} target="_blank" rel="nofollow noopener noreferrer">
          {buttonText}
        </StyledEmailLink>

        <StyledSupportLink href={supportUrl} target="_blank" rel="nofollow noopener noreferrer">
          Support My Work
        </StyledSupportLink>
      </StyledButtons>
    </StyledContainer>
  );
};

Contact.propTypes = {
  data: PropTypes.array.isRequired,
};

export default Contact;
